// import * as restaurant from './restaurant';
import * as salesChannel from './salesChannel';

const ActionCreators = {
  // ...restaurant
  ...salesChannel
};

export default ActionCreators;
